import { render, staticRenderFns } from "./IssuanceEvent.vue?vue&type=template&id=da0db57c"
import script from "./IssuanceEvent.vue?vue&type=script&lang=js"
export * from "./IssuanceEvent.vue?vue&type=script&lang=js"
import style0 from "./IssuanceEvent.vue?vue&type=style&index=0&id=da0db57c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports